module.exports = __webpack_public_path__ + "static/img/bonus_2.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_2.png
// module id = MzJO
// module chunks = 0